export const SHOW_MODAL_MENU      = "SHOW_MODAL_MENU"
export const GET_DATA_USER      = "GET_DATA_USER"
